import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { useLocalizedLanguageLinks } from 'LoginUI/hooks/useLocalizedLanguageLinks';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MarketingCta = () => {
  const {
    demoLink
  } = useLocalizedLanguageLinks();
  return /*#__PURE__*/_jsx(View, {
    flexShrink: 0,
    marginBlock: "400",
    textAlign: "center",
    children: /*#__PURE__*/_jsxs(TFlex, {
      justify: "center",
      align: "center",
      gap: 8,
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlock: "400",
        textAlign: "center",
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "loginV4.demoCta"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary-alt",
        href: demoLink,
        "data-test-id": "demo-cta-button",
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "loginV4.demoButton"
        })
      })]
    })
  });
};